export default __webpack_public_path__ + "static/media/logo_64_64.24018b26.png";